import React, { useEffect } from 'react';
import AppContactLayout from '../components/AppContactLayout';
import SubpageTopBar from './SubpageTopBar';
import { getAppConfig, isKnownAppSlug } from '../config/apps';
import NotFoundPage from './NotFoundPage';

function AppContactPage({ match }) {
  const { appSlug } = match.params;
  const validSlug = isKnownAppSlug(appSlug);
  const app = validSlug ? getAppConfig(appSlug) : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [appSlug]);

  useEffect(() => {
    if (!app) {
      return undefined;
    }
    document.title = `Contact Us – ${app.contact.brandName}`;
    return () => {
      document.title = 'East IT';
    };
  }, [app]);

  if (!validSlug || !app) {
    return <NotFoundPage />;
  }

  return (
    <div className="App">
      <SubpageTopBar />
      <AppContactLayout appSlug={appSlug} config={app.contact} />
    </div>
  );
}

export default AppContactPage;
